import React, { useState, useEffect, useRef, useContext, Fragment } from "react";

import * as Yup from "yup";
import { Formik, FieldArray, Form, Field } from "formik";
import { toast } from "react-toastify";

import { FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Paper, Select, Tab, Tabs, Collapse, Divider, Tooltip } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import SaveIcon from "@material-ui/icons/Save";
import EditIcon from "@material-ui/icons/Edit";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import { i18n } from "../../translate/i18n";
import Switch from "@material-ui/core/Switch";
import { isArray } from "lodash";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import ColorPicker from "../ColorPicker";
import { IconButton, InputAdornment } from "@material-ui/core";
import { Colorize, ExpandMore as ExpandMoreIcon } from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import ConfirmationModal from "../ConfirmationModal";
import Checkbox from '@mui/material/Checkbox';

import OptionsChatBot from "../ChatBots/options";
import CustomToolTip from "../ToolTips";

import SchedulesForm from "../SchedulesForm";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { AuthContext } from "../../context/Auth/AuthContext";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import useQueues from "../../hooks/useQueues";
import UserStatusIcon from "../UserModal/statusIcon";
import usePlans from "../../hooks/usePlans";
import ColorBoxModal from "../ColorBoxModal";
import ToggleSwitch from "../ToggleSwitch";
// import { ColorBox } from "material-ui-color";


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },

  textField1: {
    margin: theme.spacing(1),
    minWidth: 120,
  },

  btnWrapper: {
    position: "relative",
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  colorAdorment: {
    width: 20,
    height: 20,
  },
  greetingMessage: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },
  custom: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  advancedToggle: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    userSelect: "none",
    padding: "10px 0 6px",
    color: theme.palette.primary.main,
    gap: 4,
    fontWeight: 600,
    fontSize: 13,
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: 8,
  },
  advancedIcon: {
    fontSize: 18,
    transition: "transform 0.2s",
  },
  switchRow: {
    display: "flex",
    alignItems: "center",
    padding: "4px 0",
  },
  switchLabel: {
    fontSize: 14,
    fontWeight: 500,
  },
  sectionLabel: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
    marginTop: 12,
    marginBottom: 4,
  },
}));

const QueueSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  color: Yup.string().min(3, "Too Short!").max(9, "Too Long!").required(),
  greetingMessage: Yup.string(),
  chatbots: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().min(4, "too short").required("Required"),
      })
    )
    .required("Must have friends"),
});

const QueueModal = ({ open, onClose, queueId, onEdit }) => {
  const classes = useStyles();

  const initialState = {
    name: "",
    color: "",
    greetingMessage: "",
    chatbots: [],
    outOfHoursMessage: "",
    orderQueue: "",
    tipoIntegracao: "NA",
    tempoRoteador: 0,
    ativarRoteador: false,
    integrationId: "",
    fileListId: "",
    closeTicket: false,
    typeRandomMode: "RANDOM",
    randomizeImmediate: false
  };

  const [colorPickerModalOpen, setColorPickerModalOpen] = useState(false);
  const [queue, setQueue] = useState(initialState);
  const greetingRef = useRef();
  const [activeStep, setActiveStep] = useState(null);
  const [selectedQueue, setSelectedQueue] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [isStepContent, setIsStepContent] = useState(true);
  const [isNameEdit, setIsNamedEdit] = useState(null);
  const [isGreetingMessageEdit, setGreetingMessageEdit] = useState(null);
  const [queues, setQueues] = useState([]);

  const [integrations, setIntegrations] = useState([]);
  const [schedulesEnabled, setSchedulesEnabled] = useState(false);
  const [tab, setTab] = useState(0);
  const [file, setFile] = useState(null);
  const { user, socket } = useContext(AuthContext);
  const [searchParam, setSearchParam] = useState("");
  const [loading, setLoading] = useState(false);

  const [selectedQueueOption, setSelectedQueueOption] = useState("");
  const { findAll: findAllQueues } = useQueues();
  const [allQueues, setAllQueues] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const isMounted = useRef(true);

  const initialStateSchedule = [
    { weekday: i18n.t("queueModal.serviceHours.monday"), weekdayEn: "monday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: i18n.t("queueModal.serviceHours.tuesday"), weekdayEn: "tuesday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: i18n.t("queueModal.serviceHours.wednesday"), weekdayEn: "wednesday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: i18n.t("queueModal.serviceHours.thursday"), weekdayEn: "thursday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: i18n.t("queueModal.serviceHours.friday"), weekdayEn: "friday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: "Sábado", weekdayEn: "saturday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: "Domingo", weekdayEn: "sunday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" }
  ];


  const [schedules, setSchedules] = useState(initialStateSchedule);

  const companyId = user.companyId;

  const { get: getSetting } = useCompanySettings();
  const [showOpenAi, setShowOpenAi] = useState(false);
  const [showIntegrations, setShowIntegrations] = useState(false);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [showBot, setShowBot] = useState(false);
  const { getPlanCompany } = usePlans();

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);

      setShowOpenAi(planConfigs.plan.useOpenAi);
      setShowIntegrations(planConfigs.plan.useIntegrations);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchData = async () => {

      const setting = await getSetting({
        "column": "scheduleType"
      });
      if (setting.scheduleType === "queue") setSchedulesEnabled(true);
    }
    fetchData();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/files/", {
          params: { companyId }
        });

        setFile(data.files);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (!queueId) return;
      try {
        const { data } = await api.get(`/queue/${queueId}`);

        setQueue((prevState) => {
          return { ...prevState, ...data };
        });

        if (isArray(data.schedules) && data.schedules.length > 0)
          setSchedules(data.schedules);
      } catch (err) {
        toastError(err);
      }
    })();

    return () => {
      setQueue({
        name: "",
        color: "",
        greetingMessage: "",
        chatbots: [],
        outOfHoursMessage: "",
        orderQueue: "",
        tipoIntegracao: "NA",
        tempoRoteador: "",
        ativarRoteador: false,
        integrationId: "",
        fileListId: "",
        closeTicket: false,
        typeRandomMode: "RANDOM",
        randomizeImmediate: false
      });
    };
  }, [queueId, open]);

  useEffect(() => {
    if (isMounted.current) {
      const loadQueues = async () => {
        const list = await findAllQueues();
        setAllQueues(list);
        setQueues(list);

      };
      loadQueues();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (searchParam.length < 3) {
      setLoading(false);
      setSelectedQueueOption("");
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      //setLoading(true);
      const fetchUsers = async () => {
        try {
          const { data } = await api.get("/users/");
          setUserOptions(data.users);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };

      fetchUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/queueIntegration");

        setIntegrations(data.queueIntegrations);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  useEffect(() => {

    if (activeStep) {
      setSelectedQueueOption(queue.chatbots[activeStep]?.optQueueId)
    }

    if (activeStep === isNameEdit) {
      setIsStepContent(false);
    } else {
      setIsStepContent(true);
    }
  }, [isNameEdit, activeStep]);

  const handleClose = () => {
    onClose();
    setIsNamedEdit(null);
    setActiveStep(null);
    setGreetingMessageEdit(null);
  };

  const handleSaveSchedules = async (values) => {
    toast.success("Haz clic en Guardar para registrar los cambios de horario");
    setSchedules(values);
    setTab(0);
  };

  const filterOptions = createFilterOptions({
    trim: true,
  });

  const handleCloseConfirmationModal = () => {
    setConfirmModalOpen(false);
    setSelectedQueue(null);
  };

  const handleDeleteQueue = async (optionsId) => {
    try {
      await api.delete(`/chatbot/${optionsId}`);
      const { data } = await api.get(`/queue/${queueId}`);
      setQueue(initialState);
      setQueue(data);

      setIsNamedEdit(null);
      setGreetingMessageEdit(null);
      toast.success(`${i18n.t("queues.toasts.deleted")}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleSaveQueue = async (values) => {
    try {
      // Persist tipoIntegracao inside selected integration jsonContent if applicable
      if (values.integrationId && values.tipoIntegracao) {
        try {
          const { data: integrationData } = await api.get(`/queueIntegration/${values.integrationId}`);
          let baseJson = {};
          try {
            baseJson = integrationData?.jsonContent ? JSON.parse(integrationData.jsonContent) : {};
          } catch {}
          const jsonContent = {
            ...baseJson,
            tipoIntegracao: values.tipoIntegracao,
          };
          await api.put(`/queueIntegration/${values.integrationId}`, { jsonContent: JSON.stringify(jsonContent), projectName: integrationData.name });
        } catch (e) {
          // silent fail: queue save continues, but tipoIntegracao may not be persisted
        }
      }
      if (queueId) {
        await api.put(`/queue/${queueId}`, { ...values, schedules });
      } else {
        await api.post("/queue", { ...values, schedules });
      }

      toast.success(`${i18n.t("queues.toasts.success")}`);
      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  const handleSaveBot = async (values) => {
    console.log(values)
    try {
      if (queueId) {
        const { data } = await api.put(`/queue/${queueId}`, values);
        if (data.chatbots && data.chatbots.length) {
          onEdit(data);
          setQueue(data);
        }
      } else {
        const { data } = await api.post("/queue", values);
        if (data.chatbots && data.chatbots.length) {
          setQueue(data);
          onEdit(data);
          handleClose();
        }
      }

      setIsNamedEdit(null)
      setGreetingMessageEdit(null)
      toast.success(`${i18n.t("queues.toasts.success")}`);

    } catch (err) {
      toastError(err);
    }
  };

  // const renderColorBox = (open, handleClose, color, handleColorChange) => {
  //   return (
  //     <Dialog open={open} onClose={handleClose}>

  //       <DialogTitle>Escolha uma cor</DialogTitle>
  //       <DialogContent>
  //         <ColorBox
  //           disableAlpha={true}
  //           hslGradient={false}
  //           style={{ margin: '20px auto 0' }}
  //           value={color}
  //           onChange={handleColorChange} />
  //       </DialogContent>
  //       <DialogActions>
  //         <Button onClick={handleClose} color="primary">
  //           Cancelar
  //         </Button>
  //         <Button
  //           color="primary"
  //           variant="contained"
  //           className={classes.btnWrapper}
  //           onClick={handleClose} >
  //           OK
  //         </Button>
  //       </DialogActions>
  //     </Dialog>
  //   )
  // }
  return (
    <div className={classes.root}>
      <ConfirmationModal
        title={
          selectedQueue &&
          `${i18n.t("queues.confirmationModal.deleteTitle")} ${selectedQueue.name
          }?`
        }
        open={confirmModalOpen}
        onClose={handleCloseConfirmationModal}
        onConfirm={() => handleDeleteQueue(selectedQueue.id)}
      >
        {i18n.t("queueModal.title.confirmationDelete")}
      </ConfirmationModal>
      <Dialog
        maxWidth="md"
        fullWidth
        open={open}
        onClose={handleClose}
        scroll="paper"
      >
        <DialogTitle>
          {queueId
            ? `${i18n.t("queueModal.title.edit")}`
            : `${i18n.t("queueModal.title.add")}`}
        </DialogTitle>
        <Tabs
          value={tab}
          indicatorColor="primary"
          textColor="primary"
          onChange={(e, v) => setTab(v)}
          aria-label="disabled tabs example"
        >
          <Tab label={i18n.t("queueModal.title.queueData")} />
          {schedulesEnabled && <Tab label={i18n.t("queueModal.title.text")} />}
        </Tabs>
        {tab === 0 && (
          <Formik
            initialValues={queue}
            validateOnChange={false}
            enableReinitialize={true}
            validationSchema={QueueSchema}
            onSubmit={(values, actions) => {
              setTimeout(() => {
                handleSaveQueue(values);
                actions.setSubmitting(false);
              }, 400);
            }}
          >
            {({ setFieldValue, touched, errors, isSubmitting, values }) => (
              <Form>
                <DialogContent dividers style={{ padding: "16px" }}>
                  {/* ── CAMPOS BÁSICOS ── */}
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Field
                        as={TextField}
                        label={i18n.t("queueModal.form.name")}
                        autoFocus
                        name="name"
                        error={touched.name && Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={8}>
                      <Field
                        as={TextField}
                        label={i18n.t("queueModal.form.color")}
                        name="color"
                        id="color"
                        onFocus={() => { setColorPickerModalOpen(true); greetingRef.current.focus(); }}
                        error={touched.color && Boolean(errors.color)}
                        helperText={touched.color && errors.color}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <div style={{ backgroundColor: values.color }} className={classes.colorAdorment} />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <IconButton size="small" onClick={() => setColorPickerModalOpen(!colorPickerModalOpen)}>
                              <Colorize fontSize="small" />
                            </IconButton>
                          ),
                        }}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                      />
                      <ColorBoxModal
                        open={colorPickerModalOpen}
                        handleClose={() => setColorPickerModalOpen(false)}
                        onChange={(color) => setFieldValue("color", `#${color.hex}`)}
                        currentColor={values.color}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Field
                        as={TextField}
                        label="Orden"
                        name="orderQueue"
                        type="number"
                        error={touched.orderQueue && Boolean(errors.orderQueue)}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Field
                        as={TextField}
                        label={i18n.t("queueModal.form.greetingMessage")}
                        multiline
                        inputRef={greetingRef}
                        minRows={3}
                        fullWidth
                        name="greetingMessage"
                        error={touched.greetingMessage && Boolean(errors.greetingMessage)}
                        helperText={touched.greetingMessage && errors.greetingMessage}
                        variant="outlined"
                        margin="dense"
                      />
                    </Grid>
                    {schedulesEnabled && (
                      <Grid item xs={12}>
                        <Field
                          as={TextField}
                          label={i18n.t("queueModal.form.outOfHoursMessage")}
                          multiline
                          rows={3}
                          fullWidth
                          required
                          name="outOfHoursMessage"
                          error={touched.outOfHoursMessage && Boolean(errors.outOfHoursMessage)}
                          helperText={touched.outOfHoursMessage && errors.outOfHoursMessage}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                    )}
                  </Grid>

                  {/* ── ACORDEÓN AVANZADO ── */}
                  <div
                    className={classes.advancedToggle}
                    onClick={() => setShowAdvanced(v => !v)}
                  >
                    <ExpandMoreIcon
                      className={classes.advancedIcon}
                      style={{ transform: showAdvanced ? "rotate(180deg)" : "rotate(0deg)" }}
                    />
                    Configuración avanzada
                  </div>

                  <Collapse in={showAdvanced}>
                    <Grid container spacing={1} style={{ marginTop: 4 }}>
                      <Grid item xs={12}>
                        <ToggleSwitch
                          checked={!!values.closeTicket}
                          onChange={(val) => setFieldValue("closeTicket", val)}
                          label={i18n.t("queueModal.form.closeTicket")}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <ToggleSwitch
                          checked={!!values.ativarRoteador}
                          onChange={(val) => setFieldValue("ativarRoteador", val)}
                          label={i18n.t("queueModal.form.rotate")}
                        />
                      </Grid>

                      {values.ativarRoteador && (
                        <>
                          <Grid item xs={6}>
                            <FormControl variant="outlined" margin="dense" fullWidth>
                              <InputLabel>{i18n.t("queueModal.form.timeRotate")}</InputLabel>
                              <Field as={Select} name="tempoRoteador" label={i18n.t("queueModal.form.timeRotate")}>
                                <MenuItem value="1">1 min</MenuItem>
                                <MenuItem value="2">2 min</MenuItem>
                                <MenuItem value="3">3 min</MenuItem>
                                <MenuItem value="5">5 min</MenuItem>
                                <MenuItem value="10">10 min</MenuItem>
                                <MenuItem value="15">15 min</MenuItem>
                                <MenuItem value="30">30 min</MenuItem>
                                <MenuItem value="60">60 min</MenuItem>
                              </Field>
                            </FormControl>
                          </Grid>
                          <Grid item xs={6}>
                            <FormControl variant="outlined" margin="dense" fullWidth>
                              <InputLabel>{i18n.t("queueModal.form.typeRandomMode")}</InputLabel>
                              <Field as={Select} name="typeRandomMode" label={i18n.t("queueModal.form.typeRandomMode")}>
                                <MenuItem value="RANDOM">Aleatorio</MenuItem>
                                <MenuItem value="ORDENADO">Ordenado</MenuItem>
                              </Field>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12}>
                            <ToggleSwitch
                              checked={!!values.randomizeImmediate}
                              onChange={(val) => setFieldValue("randomizeImmediate", val)}
                              label={i18n.t("queueModal.form.randomizeImmediate")}
                            />
                          </Grid>
                        </>
                      )}

                      {showIntegrations && (
                        <Grid item xs={12}>
                          <FormControl variant="outlined" margin="dense" fullWidth>
                            <InputLabel id="integrationId-selection-label">{i18n.t("queueModal.form.integrationId")}</InputLabel>
                            <Field as={Select} label={i18n.t("queueModal.form.integrationId")}
                              name="integrationId" labelId="integrationId-selection-label" value={values.integrationId || ""}>
                              <MenuItem value={""}><em>Ninguna</em></MenuItem>
                              {integrations.map((integration) => (
                                <MenuItem key={integration.id} value={integration.id}>{integration.name}</MenuItem>
                              ))}
                            </Field>
                          </FormControl>
                        </Grid>
                      )}

                      {values.integrationId !== "" && (
                        <Grid item xs={12}>
                          <FormControl variant="outlined" margin="dense" fullWidth>
                            <InputLabel id="tpIntegrationId-selection-label">Tipo de Integración (SGP)</InputLabel>
                            <Field as={Select} label="Tipo de Integración" labelId="tpIntegrationId-selection-label" name="tipoIntegracao">
                              <MenuItem value="NA" disabled><em>Ninguna</em></MenuItem>
                              <MenuItem value="SB">2ª Via Boleto</MenuItem>
                              <MenuItem value="AV">A Vencer</MenuItem>
                              <MenuItem value="VE">Vencido</MenuItem>
                              <MenuItem value="LC">Liberación por Confianza</MenuItem>
                            </Field>
                          </FormControl>
                        </Grid>
                      )}

                      <Grid item xs={12}>
                        <FormControl variant="outlined" margin="dense" fullWidth>
                          <InputLabel id="fileListId-selection-label">{i18n.t("queueModal.form.fileListId")}</InputLabel>
                          <Field as={Select} label={i18n.t("queueModal.form.fileListId")}
                            name="fileListId" labelId="fileListId-selection-label" value={values.fileListId || ""}>
                            <MenuItem value={""}><em>Ninguno</em></MenuItem>
                            {file.map(f => (<MenuItem key={f.id} value={f.id}>{f.name}</MenuItem>))}
                          </Field>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Collapse>

                  {/* ── ACORDEÓN BOT ── */}
                  <div
                    className={classes.advancedToggle}
                    onClick={() => setShowBot(v => !v)}
                  >
                    <ExpandMoreIcon
                      className={classes.advancedIcon}
                      style={{ transform: showBot ? "rotate(180deg)" : "rotate(0deg)" }}
                    />
                    <span>Menú del chatbot</span>
                    <Tooltip
                      title="Configura las opciones del menú automático que aparece cuando un contacto escribe al departamento. Cada opción puede: responder con un texto, transferir a un agente o departamento, ejecutar una integración, o enviar un archivo. Si solo existe una opción, el bot la selecciona automáticamente."
                      placement="right"
                      arrow
                    >
                      <IconButton
                        size="small"
                        style={{ padding: 3, marginLeft: 2 }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <HelpOutlineOutlinedIcon style={{ fontSize: 16 }} />
                      </IconButton>
                    </Tooltip>
                  </div>
                  <Typography variant="caption" style={{ color: "gray", display: "block", marginBottom: 4, lineHeight: 1.4 }}>
                    Menú de respuestas automáticas que se activa cuando un contacto escribe al departamento por primera vez.
                  </Typography>

                  <Collapse in={showBot}>
                  <div>
                    <FieldArray name="chatbots">
                      {({ push, remove }) => (
                        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 8 }}>
                          {values.chatbots?.map((info, index) => (
                            <Paper key={`${info.id ?? index}-chatbots`} variant="outlined" style={{ borderRadius: 8, overflow: "hidden" }}>
                              <div style={{ padding: "10px 14px" }}>
                                {isNameEdit !== index && queue.chatbots[index]?.name ? (
                                  <div className={classes.greetingMessage}>
                                    <Typography style={{ flex: 1, fontWeight: 500 }} variant="body1">
                                      {values.chatbots[index].name}
                                    </Typography>
                                    <IconButton size="small" onClick={() => { setIsNamedEdit(index); setIsStepContent(false); }}>
                                      <EditIcon />
                                    </IconButton>
                                    <IconButton size="small" onClick={() => { setSelectedQueue(info); setConfirmModalOpen(true); }}>
                                      <DeleteOutline />
                                    </IconButton>
                                  </div>
                                ) : (
                                  <Grid spacing={1} container>
                                    <Grid xs={12} item>
                                      <Field
                                        as={TextField}
                                        name={`chatbots[${index}].name`}
                                        variant="outlined"
                                        margin="dense"
                                        label="Nombre de la opción"
                                        disabled={isSubmitting}
                                        autoFocus
                                        fullWidth
                                        size="small"
                                        error={touched?.chatbots?.[index]?.name && Boolean(errors.chatbots?.[index]?.name)}
                                        className={classes.textField}
                                      />
                                    </Grid>
                                    <Grid xs={12} md={8} item>
                                      <FormControl variant="outlined" margin="dense" className={classes.formControl} fullWidth>
                                        <InputLabel id="queueType-selection-label">{i18n.t("queueModal.form.queueType")}</InputLabel>
                                        <Field
                                          as={Select}
                                          name={`chatbots[${index}].queueType`}
                                          variant="outlined"
                                          margin="dense"
                                          fullWidth
                                          labelId="queueType-selection-label"
                                          label={i18n.t("queueModal.form.queueType")}
                                          error={touched?.chatbots?.[index]?.queueType && Boolean(errors?.chatbots?.[index]?.queueType)}
                                        >
                                          <MenuItem value={"text"}>{i18n.t("queueModal.bot.text")}</MenuItem>
                                          <MenuItem value={"attendent"}>{i18n.t("queueModal.bot.attendent")}</MenuItem>
                                          <MenuItem value={"queue"}>{i18n.t("queueModal.bot.queue")}</MenuItem>
                                          <MenuItem value={"integration"}>{i18n.t("queueModal.bot.integration")}</MenuItem>
                                          <MenuItem value={"file"}>{i18n.t("queueModal.bot.file")}</MenuItem>
                                        </Field>
                                      </FormControl>
                                    </Grid>
                                    <Grid xs={12} md={4} item style={{ display: "flex", alignItems: "center" }}>
                                      <FormControlLabel
                                        control={
                                          <Field
                                            as={Checkbox}
                                            color="primary"
                                            name={`chatbots[${index}].closeTicket`}
                                            checked={values.chatbots[index].closeTicket || false}
                                          />
                                        }
                                        label={i18n.t("queueModal.form.closeTicket")}
                                      />
                                      <IconButton size="small" onClick={() => values.chatbots[index].name ? handleSaveBot(values) : null} disabled={isSubmitting}>
                                        <SaveIcon />
                                      </IconButton>
                                      <IconButton size="small" onClick={() => remove(index)} disabled={isSubmitting}>
                                        <DeleteOutline />
                                      </IconButton>
                                    </Grid>
                                  </Grid>
                                )}
                              </div>

                              {isStepContent && queue.chatbots[index] && (
                                <div style={{ padding: "8px 14px 12px", borderTop: "1px solid rgba(0,0,0,0.1)" }} onClick={() => setActiveStep(index)}>
                                  {isGreetingMessageEdit !== index ? (
                                    <div className={classes.greetingMessage}>
                                      <Typography color="textSecondary" variant="body2">Mensaje:</Typography>
                                      <span style={{ flex: 1, fontSize: 13 }}>{values.chatbots[index].greetingMessage || "—"}</span>
                                      {!queue.chatbots[index]?.greetingMessage && (
                                        <CustomToolTip title={i18n.t("queueModal.bot.toolTipMessageTitle")} content={i18n.t("queueModal.bot.toolTipMessageContent")}>
                                          <HelpOutlineOutlinedIcon color="secondary" style={{ marginLeft: "4px" }} fontSize="small" />
                                        </CustomToolTip>
                                      )}
                                      <IconButton size="small" onClick={() => setGreetingMessageEdit(index)}>
                                        <EditIcon />
                                      </IconButton>
                                    </div>
                                  ) : (
                                    <Grid spacing={2} container>
                                      {(queue.chatbots[index].queueType === "text" || queue.chatbots[index].queueType === "queue" || queue.chatbots[index].queueType === "attendent" || queue.chatbots[index].queueType === "integration" || queue.chatbots[index].queueType === "file") && (
                                        <Grid xs={12} md={12} item>
                                          <Field
                                            as={TextField}
                                            name={`chatbots[${index}].greetingMessage`}
                                            label={i18n.t("queueModal.form.message")}
                                            variant="outlined"
                                            margin="dense"
                                            fullWidth
                                            multiline
                                            className={classes.textField}
                                          />
                                        </Grid>
                                      )}
                                      {queue.chatbots[index].queueType === "queue" && (
                                        <Grid xs={12} md={8} item>
                                          <FormControl variant="outlined" margin="dense" className={classes.FormControl} fullWidth>
                                            <InputLabel id="queue-selection-label">{i18n.t("queueModal.form.queue")}</InputLabel>
                                            <Field as={Select} name={`chatbots[${index}].optQueueId`} className={classes.textField1}>
                                              {queues.map(q => (<MenuItem key={q.id} value={q.id}>{q.name}</MenuItem>))}
                                            </Field>
                                          </FormControl>
                                        </Grid>
                                      )}
                                      {queue.chatbots[index].queueType === "attendent" && (
                                        <>
                                          <Grid xs={12} md={4} item>
                                            <Autocomplete
                                              style={{ marginTop: '8px' }}
                                              getOptionLabel={(option) => `${option.name}`}
                                              value={queue.chatbots[index].user}
                                              onChange={(e, newValue) => {
                                                setFieldValue(`chatbots[${index}].optUserId`, newValue?.id ?? null);
                                                if (newValue?.queues?.length === 1) {
                                                  setSelectedQueueOption(newValue.queues[0].id);
                                                  setFieldValue(`chatbots[${index}].optQueueId`, newValue.queues[0].id);
                                                }
                                                setQueues(newValue?.queues ?? allQueues);
                                                if (!newValue) setSelectedQueueOption("");
                                              }}
                                              options={userOptions}
                                              filterOptions={filterOptions}
                                              freeSolo fullWidth autoHighlight
                                              noOptionsText={i18n.t("transferTicketModal.noOptions")}
                                              loading={loading} size="small"
                                              renderOption={option => (<span><UserStatusIcon user={option} /> {option.name}</span>)}
                                              renderInput={(params) => (
                                                <TextField {...params} label={i18n.t("transferTicketModal.fieldLabel")} variant="outlined"
                                                  onChange={(e) => setSearchParam(e.target.value)}
                                                  InputProps={{ ...params.InputProps, endAdornment: (<Fragment>{loading ? <CircularProgress color="inherit" size={20} /> : null}{params.InputProps.endAdornment}</Fragment>) }}
                                                />
                                              )}
                                            />
                                          </Grid>
                                          <Grid xs={12} md={4} item>
                                            <FormControl variant="outlined" margin="dense" fullWidth className={classes.formControl}>
                                              <InputLabel>{i18n.t("transferTicketModal.fieldQueueLabel")}</InputLabel>
                                              <Select value={selectedQueueOption}
                                                onChange={(e) => { setSelectedQueueOption(e.target.value); setFieldValue(`chatbots[${index}].optQueueId`, e.target.value); }}
                                                label={i18n.t("transferTicketModal.fieldQueuePlaceholder")}>
                                                {queues.map((q) => (<MenuItem key={q.id} value={q.id}>{q.name}</MenuItem>))}
                                              </Select>
                                            </FormControl>
                                          </Grid>
                                        </>
                                      )}
                                      {queue.chatbots[index].queueType === "integration" && (
                                        <Grid xs={12} md={8} item>
                                          <FormControl variant="outlined" margin="dense" className={classes.FormControl} fullWidth>
                                            <InputLabel id="optIntegrationId-selection-label">{i18n.t("queueModal.form.integration")}</InputLabel>
                                            <Field as={Select} name={`chatbots[${index}].optIntegrationId`} className={classes.textField1}>
                                              {integrations.map(ig => (<MenuItem key={ig.id} value={ig.id}>{ig.name}</MenuItem>))}
                                            </Field>
                                          </FormControl>
                                        </Grid>
                                      )}
                                      {queue.chatbots[index].queueType === "file" && (
                                        <Grid xs={12} md={8} item>
                                          <FormControl variant="outlined" margin="dense" fullWidth>
                                            <InputLabel>Seleccionar archivo</InputLabel>
                                            <Field as={Select} name={`chatbots[${index}].optFileId`} className={classes.textField1}>
                                              {file.map(f => (<MenuItem key={f.id} value={f.id}>{f.name}</MenuItem>))}
                                            </Field>
                                          </FormControl>
                                        </Grid>
                                      )}
                                      <Grid xs={12} item>
                                        <IconButton size="small" onClick={() => handleSaveBot(values)} disabled={isSubmitting}>
                                          <SaveIcon />
                                        </IconButton>
                                      </Grid>
                                    </Grid>
                                  )}
                                  <OptionsChatBot chatBotId={info.id} />
                                </div>
                              )}
                            </Paper>
                          ))}

                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => push({ name: "", value: "" })}
                            style={{ marginTop: 4, borderRadius: 8, textTransform: "none", alignSelf: "flex-start" }}
                          >
                            + {i18n.t("queueModal.bot.addOptions")}
                          </Button>
                        </div>
                      )}
                    </FieldArray>
                  </div>
                  </Collapse>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={handleClose}
                    // color="secondary"
                    disabled={isSubmitting}
                  // variant="outlined"
                  >
                    {i18n.t("queueModal.buttons.cancel")}
                  </Button>
                  <Button
                    type="submit"
                    color="primary"
                    disabled={isSubmitting}
                    variant="contained"
                    className={classes.btnWrapper}
                  >
                    {queueId
                      ? `${i18n.t("queueModal.buttons.okEdit")}`
                      : `${i18n.t("queueModal.buttons.okAdd")}`}
                    {isSubmitting && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </Button>
                </DialogActions>
              </Form>
            )}
          </Formik>
        )}
        {tab === 1 && (
          <Paper style={{ padding: 20 }}>
            <SchedulesForm
              loading={false}
              onSubmit={handleSaveSchedules}
              initialValues={schedules}
              labelSaveButton={i18n.t("whatsappModal.buttons.okAdd")}
            />
          </Paper>
        )}
      </Dialog>
    </div >
  );
};

export default QueueModal;
